import { LocationsMassGroupsEditController } from './locations-mass-groups-edit.controller'
import { LocationsMassGroupsEditService, LOCATIONS_MASS_GROUPS_EDIT_SERVICE_NAME } from '../services/locations-mass-groups-edit'
import { LocationsMassGroupsEditErrorsSummaryService, LOCATIONS_MASS_GROUPS_EDIT_ERRORS_SUMMARY_SERVICE_NAME } from '../services/locations-mass-groups-edit'
import { UserSessionService, USER_SESSION_SERVICE_NAME } from '../../../services/user-session'
import { LocationService, LOCATION_SERVICE_NAME } from '../../../services/location'
import { GridService, GRID_SERVICE_NAME } from '../../../services/grid'

import './locations-mass-groups-edit.scss'
import * as TEMPLATE from './locations-mass-groups-edit.tpl.html'

// #region Consts

export const COMPONENT_NAME: string = 'locationsMassGroupsEdit'

// #endregion

// #region Setup

export class LocationsMassGroupsEditComponent {

    controller = [
        USER_SESSION_SERVICE_NAME,
        LOCATIONS_MASS_GROUPS_EDIT_SERVICE_NAME,
        LOCATIONS_MASS_GROUPS_EDIT_ERRORS_SUMMARY_SERVICE_NAME,
        LOCATION_SERVICE_NAME,
        GRID_SERVICE_NAME,
        (
            userSession: UserSessionService,
            massLocationGroupsEditService: LocationsMassGroupsEditService,
            massLocationGroupsEditErrorsSummaryService: LocationsMassGroupsEditErrorsSummaryService,
            locationService: LocationService,
            gridService: GridService
        ) => {
            return new LocationsMassGroupsEditController(
                userSession,
                massLocationGroupsEditService,
                massLocationGroupsEditErrorsSummaryService,
                locationService,
                gridService
            )
        }
    ]

    bindings = {
        id: '<',
        options: '<'
    } as { [index: string]: string }

    template = TEMPLATE
}

// #endregion